// import types
import RevenueActionTypes from '../types/revenue.types';
import { addItems, removeItem } from '../utils/common.util';

// set initial state
const INITIAL_STATE = {
  payments: [],
  reversedPayments: [],
  revisedPayments: [],
};

// create reducer with intial state if not state is received
const revenueReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RevenueActionTypes.SET_PAYMENTS:
      return {
        // spread in the state
        ...state,
        payments: addItems(state.payments, action.payload),
      };
    case RevenueActionTypes.REMOVE_PAYMENT:
      return {
        // spread in the state
        ...state,
        payments: removeItem(state.payments, action.payload),
      };
    case RevenueActionTypes.SET_REVERSED_PAYMENTS:
      return {
        // spread in the state
        ...state,
        reversedPayments: addItems(state.reversedPayments, action.payload),
      };
    case RevenueActionTypes.SET_REVISED_PAYMENTS:
      return {
        // spread in the state
        ...state,
        revisedPayments: addItems(state.revisedPayments, action.payload),
      };
    default:
      // no action matched, just return the state
      return state;
  }
};

// export out revenueReducer as default
export default revenueReducer;
